import Header from '@/components/common/Header.vue';
import DiseaseList from '@/components/list/DiseaseList.vue';
import { defineComponent } from 'vue';
import omoListBox from './templates/omoList.vue';
import onlineTrainList from './templates/onlineTrainList.vue';
import masterClassList from './templates/masterClassList.vue';
import exerciseList from './templates/exerciseList.vue';
import pblList from './templates/pblList.vue';
import meetingList from './templates/meetingList.vue';
import caseList from './templates/caseList.vue';
import openList from './templates/openList.vue';
import articleList from './templates/articleList.vue';
import documentList from './templates/documentList.vue';
import mallList from './templates/mallList.vue';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import { appPort, getUserId, hiddenAppNavBar } from '@/widget';
import { getKnowledgeTree } from '@/api/home';
import BScroll from '@better-scroll/core';
export default defineComponent({
    data() {
        return {
            subDepId: Number(this.$route.query.typeId) || 1,
            subDepList: [],
            moduleId: 0,
            modules: [],
            diseases: [],
            diseaseId: 0,
            flag: true,
            isApp: appPort(),
            labelId: 0,
            labelType: 'root',
            loaded: false,
            loadInd: 0,
            bs: null,
            boxWidth: 0,
            btnFlag: true,
            smallBl: false // 小布局
        };
    },
    methods: {
        changeType(id) {
            if (!this.btnFlag) {
                this.$toast('数据加载中，请稍后');
                return;
            }
            if (this.flag) {
                this.flag = false;
                this.btnFlag = false;
                this.loadInd = 0;
                // 初始化数据
                this.moduleId = 0;
                this.diseaseId = 0;
                this.smallBl = false;
                this.subDepId = Number(id);
                this.labelId = this.subDepId;
                this.labelType = 'root';
                this.$router.replace({
                    name: this.$route.name,
                    query: {
                        typeId: this.subDepId
                    }
                });
                setTimeout(() => {
                    this.flag = true;
                });
                this.modules = find(this.subDepList, { id: this.subDepId }).childNodes || [];
                this.getWidth();
            }
            else {
                this.$toast('数据加载中，请稍后');
            }
        },
        checkModule(id) {
            if (!this.btnFlag) {
                this.$toast('数据加载中，请稍后');
                return;
            }
            if (this.flag) {
                this.diseaseId = 0; // 初始化病种
                this.moduleId = Number(id);
                this.flag = false;
                this.btnFlag = false;
                this.loadInd = 0;
                if (id) {
                    this.diseases = find(this.modules, { id: id }).childNodes;
                    if (this.diseases.length) {
                        this.diseaseId = this.diseases[0].id;
                        this.labelId = this.diseaseId;
                        this.labelType = 'node';
                        this.smallBl = true;
                    }
                    else {
                        this.labelType = 'root';
                        this.labelId = this.subDepId;
                        this.smallBl = false;
                    }
                }
                else {
                    this.labelType = 'root';
                    this.labelId = this.subDepId;
                    this.diseases = [];
                    this.diseaseId = 0;
                    this.smallBl = false;
                }
                setTimeout(() => {
                    this.flag = true;
                });
            }
            else {
                this.$toast('数据加载中，请稍后');
            }
        },
        checkDisease(id) {
            if (!this.btnFlag) {
                this.$toast('数据加载中，请稍后');
                return;
            }
            if (this.flag) {
                this.$showLoading();
                this.diseaseId = Number(id);
                this.labelId = id;
                this.labelType = 'node';
                this.flag = false;
                this.btnFlag = false;
                this.loadInd = 0;
                setTimeout(() => {
                    this.$hideLoading();
                }, 500);
                setTimeout(() => {
                    this.flag = true;
                });
            }
            else {
                this.$toast('数据加载中，请稍后');
            }
        },
        initFlag() {
            this.loadInd++;
            if (this.loadInd === 10) {
                this.$hideLoading();
                this.btnFlag = true;
            }
            setTimeout(() => {
                if (this.loadInd <= 10) {
                    this.btnFlag = true;
                }
            }, 800);
        },
        getTree() {
            if (!this.flag) {
                return;
            }
            this.flag = false;
            let userId = getUserId();
            getKnowledgeTree(userId).then(res => {
                if (res.code === 200) {
                    this.subDepList = res.data;
                    if (!this.$route.query.typeId || findIndex(this.subDepList, { id: this.subDepId }) === -1) {
                        this.subDepId = this.subDepList[0] && this.subDepList[0].id;
                    }
                    this.labelId = this.subDepId;
                    this.labelType = 'root';
                    this.modules = find(this.subDepList, { id: this.subDepId }).childNodes;
                    this.loaded = true;
                    this.flag = true;
                    this.getWidth();
                }
                else {
                    this.$toast(res.message);
                }
            });
        },
        getWidth() {
            this.boxWidth = 0;
            this.$nextTick(() => {
                var children = this.$refs.skillListBox.children;
                for (var i = 0; i < children.length; i++) {
                    this.boxWidth += children[i].offsetWidth;
                }
                var rem = Number(localStorage.getItem('rem') || 0);
                var n = rem * 0.68;
                // @ts-ignore;
                this.boxWidth = this.boxWidth + Math.ceil(n) + 'px';
                this.$nextTick(() => {
                    this.setBs();
                });
            });
        },
        setBs() {
            this.bs && this.bs.destroy();
            this.bs = new BScroll(this.$refs.skillList, {
                scrollY: false,
                scrollX: true,
                click: true
            });
        }
    },
    mounted() {
        if (this.isApp) {
            hiddenAppNavBar();
        }
        this.getTree();
    },
    components: {
        Header,
        DiseaseList,
        omoListBox,
        onlineTrainList,
        masterClassList,
        exerciseList,
        pblList,
        meetingList,
        caseList,
        openList,
        articleList,
        documentList,
        mallList
    }
});
